import moment from "moment";

export function calculateDaysRemaining(finalDate, startDate = null) {
   const finalDateFormatted = moment(finalDate);
   const startDateFormatted = startDate ?
      moment(startDate).format("LLLL")
      :
      moment().format("LLLL");

   return finalDateFormatted.diff(startDateFormatted, 'days') + 1;
}

export function createDynamicStartDate(timeUnitFromInitialDate, initialDate = null) {
   return initialDate ? moment(initialDate).add(timeUnitFromInitialDate, "days").format("YYYY-MM-DD") : moment().add(timeUnitFromInitialDate, "days").format("YYYY-MM-DD");
}

export function formatCustomDate(date) {
   return moment(date).format("LLLL");
}

export function getCurrentDate() {
   return moment.format("LLLL");
}


